"use client";

import { AnimatePresence, motion } from "motion/react";
import { UploadCloud } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

interface DragDropOverlayProps {
  isDragging: boolean;
  className?: string;
}

export function DragDropOverlay({ isDragging, className }: DragDropOverlayProps) {
  const { t } = useTranslation(["chat"]);

  return (
    <AnimatePresence>
      {isDragging && (
        <motion.div
          animate={{ opacity: 1 }}
          className={cn(
            "pointer-events-none absolute inset-0 z-[100] flex flex-col items-center justify-center gap-4 rounded-lg bg-black/50 backdrop-blur-sm",
            className,
          )}
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <UploadCloud className="h-16 w-16 text-white" />
          <div className="text-center">
            <h3 className="text-2xl font-bold text-white">{t("chat:dragDrop.title")}</h3>
            <p className="text-muted-foreground">{t("chat:dragDrop.description")}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
